import {
  cancelForAnyReason,
  cancellationInsideEu,
  cancellationOutsideEu,
  flexibleTicket,
  seatMap,
} from '@eti/products';
import { selectionContainsNoneOption } from '../../../utils/addedExtraProducts';

const getMinFlexibleTicketPrice = (options = []) =>
  options.reduce(
    (total, { price }) => (total ? Math.min(price.price.value, total) : price.price.value),
    null,
  );

const getCFARTicketProduct =
  (form, names = {}, cfarTicketProduct) =>
  (state) => {
    if (cfarTicketProduct) {
      const selected = cancelForAnyReason.getSelected(form)(state);
      if (!selected) {
        return [
          {
            id: cancelForAnyReason.id,
            name: cancelForAnyReason.name,
            price: cfarTicketProduct.sellSpecification.price.price.value,
            priceText: 'Products.Price.Label.Only',
            title: names[cancelForAnyReason.name],
          },
        ];
      }
    }

    return [];
  };

const getFlexibleTicketProduct =
  (form, names = {}, flexibleTicketProduct) =>
  (state) => {
    if (flexibleTicketProduct) {
      const selected = flexibleTicket.getSelected(form)(state);

      if (selectionContainsNoneOption(selected)) {
        return [
          {
            id: flexibleTicket.id,
            name: flexibleTicket.name,
            price: getMinFlexibleTicketPrice(
              flexibleTicketProduct.sellSpecification.sellPriceTravelers,
            ),
            priceText: 'Products.Price.Label.From',
            title: names[flexibleTicket.name],
          },
        ];
      }
    }

    return [];
  };

const getCancellationProductSumPrice = (options = []) =>
  options.reduce((total, { price }) => total + price.price.value, null);

const getCancellationProduct =
  (form, names = {}, cancellationProduct) =>
  (state) => {
    if (cancellationProduct) {
      const cancellation = [cancellationInsideEu, cancellationOutsideEu].find(
        (product) => product.id === cancellationProduct.id,
      );
      const selected = cancellation.getSelected(form)(state);

      if (!selected) {
        return [
          {
            id: cancellation.id,
            name: cancellation.name,
            price: getCancellationProductSumPrice(
              cancellationProduct.sellSpecification.sellPriceTravelers,
            ),
            priceText: 'Products.Price.Label.Only',
            title: names[cancellation.name],
          },
        ];
      }
    }

    return [];
  };

const getSeatMapProduct =
  (form, names = {}, seatMapProduct) =>
  (state) => {
    if (seatMapProduct) {
      const selected = seatMap.isSelected(form)(state);
      const selection = seatMap.getSelection(form)(state);
      const bounds = seatMapProduct ? seatMapProduct.sellSpecification.sellSeatMapBounds : [];

      if (!selected && Array.isArray(selection) && selection.length === 0) {
        return [
          {
            id: seatMap.id,
            name: seatMap.name,
            price: seatMap.getMinPrice(bounds),
            priceText: 'Products.Price.Label.From',
            title: names[seatMap.name],
          },
        ];
      }
    }

    return [];
  };

export {
  getCFARTicketProduct,
  getCancellationProduct,
  getFlexibleTicketProduct,
  getSeatMapProduct,
};

export const getSeatMapExtraProductStructure = (product) => {
  if (!product) {
    return null;
  }

  return {
    ...product,
    persuasion: {
      isEnabled: product?.configuration?.travelerDetails?.persuasionEnabled,
    },
    sellSpecification: {
      ...product.sellSpecification,
      sellSeatMapBounds: seatMap.transformSeatmapPrices(
        product.sellSpecification.sellSeatMapBounds,
      ),
    },
  };
};
